'use client'
import { VideoPlayer } from 'components/VideoPlayer'

function StateVideoSection({ source, thumbnail, altText, title, videoUrl }) {
  // Support both object format and simple string URL
  const videoSource = source || videoUrl

  if (!videoSource) {
    return null
  }

  return (
    <section className="mx-auto max-w-7xl px-5 py-8 md:px-6">
      <div className="w-full flex justify-center">
        <div className="w-full max-w-[693.681px] border-4 border-blue-500 rounded-lg overflow-hidden">
          <VideoPlayer
            content={{
              source: videoSource,
              thumbnail,
              altText: altText || title || 'State video',
              autoplay: false,
            }}
            frameClassName="w-full h-auto"
            frameEmbed={true}
            aspectRatio={16 / 9}
            capWidth={693.681}
          />
        </div>
      </div>
    </section>
  )
}

export { StateVideoSection }
export default StateVideoSection
